import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { UpdateProfileRequestDto, UpdateProfileResponseDto } from "../types/dto";

import { contactsSearchProfilesQueryKeys } from "./queryKeyFactory";

export const useUpdateContactProfileMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<UpdateProfileResponseDto, Error, UpdateProfileRequestDto>({
        mutationFn: (payload) => salesApiService.contactsSearchProfiles.updateProfile(payload),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: contactsSearchProfilesQueryKeys.allProfiles() });
        },
    });
};
